var timeAgo = function (timeDifference) {
    if (timeDifference < 0) {
        return 'just now';
    }
    else {
        var seconds = Math.round(timeDifference) / 1000;
        var minutes = Math.round(seconds / 60);
        var hours = Math.round(seconds / (60 * 60));
        var days = Math.round(seconds / (60 * 60 * 24));
        var months = Math.round(seconds / (60 * 60 * 24 * 30));
        var years = Math.round(seconds / (60 * 60 * 24 * 30 * 356.25));
        if (years > 0) {
            return "".concat(years, " ").concat(years === 1 ? 'year' : 'years', " ago");
        }
        else if (months > 0) {
            return "".concat(months, " ").concat(months === 1 ? 'month' : 'months', " ago");
        }
        else if (days > 0) {
            return "".concat(days, " ").concat(days === 1 ? 'day' : 'days', " ago");
        }
        else if (hours > 0) {
            return "".concat(hours, " ").concat(hours === 1 ? 'hour' : 'hours', " ago");
        }
        else if (minutes > 0) {
            return "".concat(minutes, " ").concat(minutes === 1 ? 'minute' : 'minutes', " ago");
        }
        else {
            return 'just now';
        }
    }
};
export default timeAgo;
